export default __webpack_public_path__ + "static/media/model-y.30acb76a.jpg";